export const DEFAULT_CATEGORY_COLORS = [
    // Reds & Pinks
    '#E53935', // Vibrant Red
    '#C62828', // Dark Red
    '#D81B60', // Deep Pink
    '#EC407A', // Pink
    '#F06292', // Light Pink

    // Oranges
    '#FF6F00', // Deep Orange
    '#F57C00', // Orange
    '#FB8C00', // Bright Orange
    '#FFA726', // Light Orange
    '#FFB74D', // Peach

    // Yellows & Golds
    '#F9A825', // Golden Yellow
    '#FBC02D', // Yellow
    '#FDD835', // Bright Yellow
    '#FFEB3B', // Light Yellow
    '#FFD54F', // Pale Yellow

    // Greens
    '#2E7D32', // Forest Green
    '#388E3C', // Green
    '#43A047', // Medium Green
    '#66BB6A', // Light Green
    '#81C784', // Pale Green
    '#00695C', // Teal Green
    '#00897B', // Teal
    '#26A69A', // Light Teal

    // Blues
    '#01579B', // Deep Blue
    '#0277BD', // Blue
    '#0288D1', // Sky Blue
    '#039BE5', // Bright Blue
    '#29B6F6', // Light Blue
    '#4FC3F7', // Pale Blue
    '#1565C0', // Royal Blue
    '#1976D2', // Medium Blue

    // Purples & Violets
    '#4A148C', // Deep Purple
    '#6A1B9A', // Purple
    '#7B1FA2', // Violet
    '#8E24AA', // Medium Purple
    '#AB47BC', // Light Purple
    '#BA68C8', // Lavender
    '#512DA8', // Indigo
    '#5E35B1', // Medium Indigo

    // Browns & Earthy
    '#4E342E', // Dark Brown
    '#5D4037', // Brown
    '#6D4C41', // Medium Brown
    '#795548', // Light Brown
    '#A1887F', // Tan

    // Grays & Neutrals
    '#37474F', // Dark Slate
    '#455A64', // Slate
    '#546E7A', // Blue Gray
    '#607D8B', // Light Slate
    '#78909C', // Pale Gray
] as const;

export function getRandomAvailableColor(existingColors: string[]): string {
    const availableColors = DEFAULT_CATEGORY_COLORS.filter(color => !existingColors.includes(color));

    if (availableColors.length === 0) {
        // If all colors are used, return a random one from the full palette
        return DEFAULT_CATEGORY_COLORS[Math.floor(Math.random() * DEFAULT_CATEGORY_COLORS.length)] as string;
    }

    return availableColors[Math.floor(Math.random() * availableColors.length)] as string;
}

export function isDefaultCategoryColor(color: string): boolean {
    return DEFAULT_CATEGORY_COLORS.includes(color as (typeof DEFAULT_CATEGORY_COLORS)[number]);
}
